import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";


export function CoberturaTiendasViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    let fillColor: string;
    const cobertura_compartida = record[5] as string;
    const cobertura_exclusiva = record[6] as string;
    const canales = record[2];
    const cadena = record[1];

    if ((cobertura_compartida === 'OK' && cobertura_exclusiva === 'OK') || (cobertura_compartida === 'OK' && cobertura_exclusiva === '') || (cobertura_compartida === '' && cobertura_exclusiva === 'OK')) {
        fillColor = theme.colors.green[6];
    }
    else if (cobertura_compartida === 'OK' || cobertura_exclusiva === 'OK') {
        fillColor = theme.colors.yellow[6];
    }
    else if (cobertura_compartida !== 'Sin rutas compartidas asignadas' && cobertura_exclusiva !== 'Sin rutas exclusivas asignadas') {
        fillColor = theme.colors.yellow[6];
    }
    else {
        fillColor = theme.colors.red[6];
    }

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${canales}${canales && cadena ? ' - ' : ''}${cadena}`,
        fillColor: fillColor
    }
    return markerProps;
}